<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaProcedimentos"
        title-table="Procedimentos"
        module="procedimentosSettingsModule"
        sort-name="descricao"
        :add-permission="'ROLE_PROCEDIMENTO_INSERIR'"
        :view-permission="'ROLE_PROCEDIMENTO_CONSULTAR'"
        :edit-permission="'ROLE_PROCEDIMENTO_ATUALIZAR'"
        :delete-permission="'ROLE_PROCEDIMENTO_DELETAR'"
        :search-field="'descricao'"
        @add="addNew"
        @edit="edit"
      />
      <FormProcedimento
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import mixinsGlobal from '@/mixins'
import FormProcedimento from './forms/FormProcedimento.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormProcedimento,
  },
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('procedimentosSettingsModule', {
      listaProcedimentos: state => state.listaProcedimentos,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id',
        },
        {
          label: 'Descrição',
          field: 'descricao',
        },
        {
          label: 'Especialidade',
          field: 'especialidade.descricao',
        },
        {
          label: 'Ativo',
          field: 'ativo',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.$store.dispatch('procedimentosSettingsModule/reset')
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('procedimentosSettingsModule/prepareToEdit', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
